import { memo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import ChallengesRedirect from "@/common/ChallengesRedirect";
import { Routes as AppRoutes } from "@/constants/routes";
import { lazyWithPreload } from "@/utils/lazyPreload";

const BothFlow = lazyWithPreload(() => import("@/components/BothFlow"));
const AppEmailFlow = lazyWithPreload(() => import("../AppEmailFlow"));
const AuthFlow = lazyWithPreload(() => import("../AuthFlow.jsx"));

const ShareVideo = lazyWithPreload(() => import("../components/ShareVideo"));
const WrapperProviders = lazyWithPreload(() => import("../components/WrapperProviders"));

const Router = () => {
    return (
        <WrapperProviders>
            <Routes>
                <Route path="*" element={<Navigate to="/" />} />
                <Route path={`${AppRoutes.Both}/*`} element={<BothFlow />} />
                <Route path={`${AppRoutes.Funnel}/${AppRoutes.Both}/*`} element={<BothFlow />} />
                <Route path={`${AppRoutes.BothGoogle}/*`} element={<BothFlow />} />
                <Route
                    path={`${AppRoutes.Funnel}/${AppRoutes.BothGoogle}/*`}
                    element={<BothFlow />}
                />
                <Route path={AppRoutes.PromoPaywall} element={<AppEmailFlow />} />
                <Route path="auth" element={<AuthFlow />} />
                <Route path="simplified-auth" element={<AuthFlow withoutZipCode />} />
                <Route path="/share-video" element={<ShareVideo />} />
                <Route path={AppRoutes.NewYear} element={<Navigate to={`/${AppRoutes.Both}`} />} />
                <Route path={AppRoutes.ChallengesRedirect} element={<ChallengesRedirect />} />
                <Route path={`${AppRoutes.Offer}/*`} element={<BothFlow />} />
            </Routes>
        </WrapperProviders>
    );
};

export default memo(Router);
